import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';
import './ChartWidget.scss';

interface ChartWidgetProps {
  spec: any;
  onAction?: (actionType: string, parameters: any) => void;
}

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];

export const ChartWidget: React.FC<ChartWidgetProps> = ({ spec, onAction }) => {
  const { title, data, xAxis, yAxis, color, widget_id } = spec;

  const renderChart = () => {
    // Determine chart type from widget_id
    if (widget_id && widget_id.includes('_bar')) {
      return (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xAxis} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey={yAxis} fill={color || '#0088FE'} />
          </BarChart>
        </ResponsiveContainer>
      );
    } else if (widget_id && widget_id.includes('_line')) {
      return (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xAxis} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey={yAxis} stroke={color || '#00C49F'} />
          </LineChart>
        </ResponsiveContainer>
      );
    } else if (widget_id && widget_id.includes('_pie')) {
      return (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={(entry: any) => entry.name}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry: any, index: number) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      );
    }

    // Default to bar chart
    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xAxis} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey={yAxis} fill={color || '#0088FE'} />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  return (
    <div className="chart-widget">
      {title && <h4 className="chart-title">{title}</h4>}
      {renderChart()}
    </div>
  );
};
